import React from "react";
import { FormCamposProps } from "./FormCamposProps";
import { nanoid } from "nanoid";
import Modal from "@/components/layout/Modal";
import Grid, { GridItem } from "@/components/layout/Grid";
import CampoCheckbox from "@/components/Formulario/CampoCheckbox";
import CampoTexto from "@/components/Formulario/CampoTexto";
import Botao from "@/components/Botao";
import { mdiKeyPlus } from "@mdi/js";
import AlertBox from "@/components/layout/AlertBox";
import CodeBlock from "@/components/layout/CodeBlock";

export const FormCamposWebchat = ({
    host,
    value,
    onChange,
    fieldErrors,
}: FormCamposProps) => {
    const [showModal, setShowModal] = React.useState(false);

    const data = value
        ? JSON.parse(value)
        : {
            apikey: '',
            kioskMode: false,
        };

    const generate = () => {
        onChange?.(JSON.stringify({ ...data, apikey: nanoid(32) }));
    };

    React.useEffect(() => {
        if (!value?.length) {
            generate();
        }
    }, []);

    const openModal = () => {
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };

    const onConfirm = () => {
        generate();
        closeModal();
    };
    return (
        <>
            <Modal
                show={showModal}
                title="Gerar nova chave API"
                size="sm"
                onClose={closeModal}
                onCancel={closeModal}
                onConfirm={onConfirm}
                confirmProps={{ label: 'Sim, Gerar nova chave', variant: 'warning' }}
            >
                <p>
                    Trocar a chave pode invalidar scripts já instalados, e tornar estas
                    telas de webchat indisponíveis.
                </p>
                <p>Tem certeza que deseja gerar uma nova chave API?</p>
            </Modal>

            <Grid>
                <GridItem sm={12} md={2}>
                    <CampoCheckbox
                        label="Modo Quiosque"
                        value={Boolean(data.kioskMode)}
                        onChange={v =>
                            onChange?.(JSON.stringify({ ...data, kioskMode: v }))
                        }
                    >
                        Habilitar
                    </CampoCheckbox>
                </GridItem>
                <GridItem sm={12} md={10}>
                    <CampoTexto
                        label="Chave API do webchat"
                        value={data.apikey}
                        onChange={v => onChange?.(JSON.stringify({ ...data, apikey: v }))}
                        autoFill="do-not-autofill-please"
                        error={fieldErrors?.['chave_api']}
                        append={
                            <Botao
                                variant="none-warning"
                                icon={mdiKeyPlus}
                                size="16"
                                onClick={openModal}
                            />
                        }
                    />
                </GridItem>
            </Grid>
            <AlertBox variant="info">
                <p>
                    Segue um exemplo de código para incorporar o webchat em seu site, no
                    final do conteúdo:
                </p>
                <CodeBlock
                    value={`
<!-- Inicio webchat -->
<style>
.__tc-btn {
    position: fixed;
    bottom: 10px;
    right: 10px;
    height: 48px;
    width: 48px;
    border-radius: 50%;
    background-color: #103668;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.__tc-container {
    display: none; 
    border: 1px solid #bbffbb; 
    border-radius: 8px; 
    position:fixed; 
    bottom:60px; 
    right: 15px; 
    height:calc(80vh - 30px); 
    width: 20vw; 
    min-width: 280px; 
    z-index: 10000
}
</style>
<script>
    var $id = document.getElementById.bind(document);
    function _t() { var el = $id('tc-webchat'); if (el.style.display === 'block') { el.style.display = 'none'; } else { el.style.display = 'block'; } }
</script>
<div  class="__tc-btn" onclick="_t()">
    <img src="${host ?? ''}/logo.png" alt="open webchat" style="height: 40px;" />
</div>
<iframe id="tc-webchat" src="${host ?? ''}/webchat?apikey=${data.apikey ?? '[APIKEY]'}" class="__tc-container"></iframe>
<!-- Fim webchat -->
        `}
                />
            </AlertBox>
        </>
    );
};
